import "./AGB.css";

export default function AGB() {
  return (
    <div className="agb-container">

      <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>

      <p>
        Die folgenden Allgemeinen Geschäftsbedingungen gelten für sämtliche
        Lieferungen und Leistungen der Firma <strong>Wintergartenmeister</strong>.
      </p>

      {/* SECTION 1 */}
      <section className="agb-section">
        <h2>§1 Geltungsbereich & Begriffsbestimmungen</h2>

        <p>
          Diese Allgemeinen Geschäftsbedingungen gelten für alle Bestellungen,
          Lieferungen und Leistungen zwischen Wintergartenmeister und unseren Kunden
          in der jeweils aktuellen Fassung zum Zeitpunkt der Bestellung.
        </p>

        <p>
          Verbraucher im Sinne dieser Bedingungen ist jede natürliche Person,
          die ein Rechtsgeschäft zu privaten Zwecken abschließt und nicht überwiegend
          einer gewerblichen oder selbstständigen Tätigkeit zugeordnet werden kann.
        </p>
      </section>

      {/* SECTION 2 */}
      <section className="agb-section">
        <h2>§2 Vertragsabschluss & Speicherung</h2>

        <p>
          Die Darstellung unserer Produkte und Dienstleistungen auf unserer Website
          stellt kein verbindliches Angebot dar, sondern dient lediglich zur
          unverbindlichen Präsentation unseres Sortiments.
        </p>

        <p>
          Mit dem Absenden einer Bestellung gibt der Kunde ein verbindliches Angebot
          zum Abschluss eines Kaufvertrages ab.
        </p>

        <div className="agb-box">
          <h3>Vertragspartner</h3>

          <p>Wintergartenmeister</p>
          <p>Ertugrul Erkan</p>
          <p>Robert Stolz Straße 23</p>
          <p>47057 Düsseldorf</p>

          <p>
            Hinweis: Umsatzsteuer wird gemäß den gesetzlichen Vorschriften
            ausgewiesen.
          </p>
        </div>

        <h3>Bestellablauf</h3>

        <ul>
          <li>Auswahl der gewünschten Produkte oder Leistungen</li>
          <li>Hinzufügen zum Warenkorb</li>
          <li>Überprüfung der eingegebenen Daten</li>
          <li>Abschluss der Bestellung</li>
          <li>Erhalt einer automatischen Bestellbestätigung per E-Mail</li>
        </ul>

        <p>
          Vor dem endgültigen Absenden der Bestellung können Eingabefehler jederzeit
          korrigiert werden.
        </p>
      </section>

      {/* SECTION 3 */}
      <section className="agb-section">
        <h2>§3 Preise & Zahlungsbedingungen</h2>

        <p>
          Alle angegebenen Preise verstehen sich inklusive der gesetzlichen
          Mehrwertsteuer, sofern nicht anders angegeben.
        </p>

        <p>
          Zusätzlich können Versand- oder Lieferkosten anfallen.
        </p>

        <h3>Mögliche Zahlungsarten</h3>

        <ul>
          <li>Vorkasse</li>
          <li>PayPal</li>
          <li>Kreditkarte</li>
          <li>Banküberweisung</li>
        </ul>

        <p>
          Bei Auswahl der Zahlungsart Vorkasse verpflichtet sich der Kunde,
          den Rechnungsbetrag unmittelbar nach Vertragsabschluss zu begleichen.
        </p>
      </section>

      {/* SECTION 4 */}
      <section className="agb-section">
        <h2>§4 Lieferung</h2>

        <p>
          Sofern in der jeweiligen Produktbeschreibung keine andere Lieferzeit
          angegeben wird, erfolgt die Lieferung innerhalb der vereinbarten Frist.
        </p>

        <p>
          Die Lieferfrist beginnt:
        </p>

        <ul>
          <li>bei Vorkasse nach Zahlungseingang</li>
          <li>bei anderen Zahlungsarten nach Vertragsabschluss</li>
        </ul>

        <p>
          Sollte das Lieferende auf einen Sonn- oder Feiertag fallen,
          verschiebt sich die Lieferung auf den nächsten Werktag.
        </p>

        <p>
          Die Gefahr der zufälligen Verschlechterung oder des Verlustes der Ware
          geht erst mit Übergabe an den Kunden über.
        </p>
      </section>

      {/* SECTION 5 */}
      <section className="agb-section">
        <h2>§5 Eigentumsvorbehalt</h2>

        <p>
          Bis zur vollständigen Bezahlung bleibt die gelieferte Ware Eigentum
          von Wintergartenmeister.
        </p>
      </section>

      {/* SECTION 6 */}
      <section className="agb-section">
        <h2>§6 Widerrufsrecht</h2>

        <p>
          Verbraucher haben das Recht, den Vertrag innerhalb von vierzehn Tagen
          ohne Angabe von Gründen zu widerrufen.
        </p>

        <p>
          Die Widerrufsfrist beginnt an dem Tag, an dem die Ware vom Kunden
          oder einer benannten Person entgegengenommen wurde.
        </p>

        <div className="agb-box">
          <h3>Kontakt für Widerruf</h3>

          <p>Wintergartenmeister</p>
          <p>Ertugrul Erkan</p>
          <p>Robert Stolz Straße 23</p>
          <p>47057 Düsseldorf</p>
          <p>E-Mail: ceysaas@gmail.com</p>
          <p>Telefon: +49 174 7086562</p>
        </div>

        <p>
          Zur Ausübung des Widerrufs genügt eine eindeutige Mitteilung
          per E-Mail oder Post.
        </p>
      </section>

      {/* SECTION 7 */}
      <section className="agb-section">
        <h2>§7 Folgen des Widerrufs</h2>

        <p>
          Im Falle eines wirksamen Widerrufs werden bereits geleistete Zahlungen
          innerhalb von vierzehn Tagen zurückerstattet.
        </p>

        <p>
          Die Rückzahlung erfolgt über dasselbe Zahlungsmittel,
          das bei der ursprünglichen Transaktion verwendet wurde.
        </p>

        <p>
          Der Kunde trägt die unmittelbaren Kosten der Rücksendung,
          sofern nichts anderes vereinbart wurde.
        </p>
      </section>

      {/* SECTION 8 */}
      <section className="agb-section">
        <h2>§8 Gewährleistung</h2>

        <p>
          Es gelten die gesetzlichen Gewährleistungsrechte nach deutschem Recht.
        </p>
      </section>

      {/* SECTION 9 */}
      <section className="agb-section">
        <h2>§9 Vertragssprache</h2>

        <p>
          Die Vertragssprache ist ausschließlich Deutsch.
        </p>
      </section>

      {/* SECTION 10 */}
      <section className="agb-section">
        <h2>§10 Verbraucherstreitbeilegung</h2>

        <p>
          Wintergartenmeister ist nicht verpflichtet und nicht bereit,
          an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
          teilzunehmen.
        </p>
      </section>

      <p className="agb-date">
        Stand der AGB: Mai 2026
      </p>

       
    </div>
  );
}